// extracted by mini-css-extract-plugin
export default {"icon6":"ToTop_icon6__Lhtq5"};